import React from 'react';
import { Hero } from './components/Hero';
import { ServiceHighlights } from './components/ServiceHighlights';
import { TrustSection } from './components/TrustSection';
import { AboutSection } from './components/AboutSection';
import { ContactCTA } from './components/ContactCTA';
import { SEOHead } from './components/SEOHead';
export function App() {
  return <main className="bg-dark-bg min-h-screen w-full text-gold-100 selection:bg-gold-400 selection:text-dark-bg" data-id="element-0">
      <SEOHead data-id="element-1" />
      <Hero data-id="element-2" />
      <ServiceHighlights data-id="element-3" />
      <TrustSection data-id="element-4" />
      <AboutSection data-id="element-5" />
      <ContactCTA data-id="element-6" />
    </main>;
}